export enum Level {
  BEGINNER = "Beginner",
  MEDUIM = "Meduim",
  ADVANCED = "Adcanced",
}
